var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDialogOpen)?_c('UserDialog',{key:_vm.id,attrs:{"is-open":_vm.isDialogOpen,"title":"Edit User","actionName":"Save Changes","userRoles":_vm.userRoles,"userData":_vm.user,"isLoadingUserRoles":_vm.isLoadingUserRoles,"loading":_vm.isEditingUserDetails,"isUpdate":""},on:{"close":_vm.close,"submit":_vm.handleEdit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }